import React, { useCallback } from 'react';
import { Checkbox } from '@ontruck/orc';
import { useSelectedTasksContext } from 'modules/tasks/lists/context';

const t = {
  select: 'Select all',
};

function getListOfIds(list) {
  return list.map((group) => group.id);
}

const SelectAll = ({ className, groupedTasks, title }) => {
  const { setSelected, selectAllEnabled, setSelectAllEnabled } = useSelectedTasksContext();

  const selectTasksFromList = useCallback(() => {
    setSelectAllEnabled((prevState) => ({ ...prevState, [title]: true }));
    setSelected((prevState) => [...prevState, ...getListOfIds(groupedTasks)]);
  }, [groupedTasks, title, setSelectAllEnabled, setSelected]);

  const unselectListOfTasks = useCallback(() => {
    setSelectAllEnabled((prevState) => ({ ...prevState, [title]: false }));
    setSelected((prevState) => prevState.filter((id) => !getListOfIds(groupedTasks).includes(id)));
  }, [groupedTasks, title, setSelectAllEnabled, setSelected]);

  const handleSelectAll = useCallback(
    (e) => {
      e.stopPropagation();
      return selectAllEnabled[title] ? unselectListOfTasks() : selectTasksFromList();
    },
    [selectAllEnabled, title, unselectListOfTasks, selectTasksFromList]
  );

  return (
    <span className={className} onClick={handleSelectAll}>
      <span className="text">{t.select}</span>
      <Checkbox
        checked={selectAllEnabled[title]}
        onChange={() => {
          /*noop*/
        }}
      />
    </span>
  );
};

export default SelectAll;
